const u = navigator.userAgent
export const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
